import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const AlertWrapper = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px;
    margin-top: 16px;
    background: ${colorsPalettes.carbon[25]};
    ${setFontVariant("caption")}
`;

export const IconWrapper = styled.span`
    margin-right: 8px;

    svg {
        path {
            fill-rule: evenodd;
        }
    }
`;

export const TextWrapper = styled.p`
    margin: 0;
    color: ${colorsPalettes.carbon["400"]};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
